import { AxiosResponse } from "axios";
import axiosInstance from "../../../interceptors/axiosInstance";
import { DividendoValores } from "../models/dividendos";
import { useToast } from "../../../hooks/useToast";
import { ExtincionDto } from "../models/extincionDto";
const BASE_PATH_DIV = 'siscred-api-dividendos/v1/dividendos';
const BASE_CARTERA_PATH_DIV = 'siscred-api-cartera-total/v1/dividendos';

const getValoresDividendo = async (idMutuo: number) => {
    const response: AxiosResponse = await axiosInstance.get(
        `${BASE_PATH_DIV}/obtener-valores-div/${idMutuo}`
    );
    return response;
};

const getValoresCuotas = async (valores: DividendoValores) => {
    const response: AxiosResponse = await axiosInstance.post(
        `${BASE_PATH_DIV}/obtener-cuotas`,
        valores
    );
    return response;
};

const postGuardarDivIndividual = async (valores: DividendoValores) => {
    const response: AxiosResponse = await axiosInstance.post(
        `${BASE_PATH_DIV}/guarda-individual`,
        valores
    );
    return response;
};

const getRecalculo = async (valores: DividendoValores) => {
    const response: AxiosResponse = await axiosInstance.post(
        `${BASE_PATH_DIV}/calcular`,
        valores
    );
    return response;
};

const extinguirMutuo = async (extincionDto: ExtincionDto, mutuoId: number) => {
    const response: AxiosResponse = await axiosInstance.post(`${BASE_PATH_DIV}/extinguir?idMutuo=${mutuoId}`, extincionDto);
    return response;
};

export {
    getValoresDividendo,
    getValoresCuotas,
    postGuardarDivIndividual,
    getRecalculo,
    extinguirMutuo
}
